import React, { useId } from "react";
import { ChakraBox, ChakraSvg } from "ui/chakra-framer";

const negativeXMargin = `calc(-1 * var(--chakra-space-containerPx-mobile))`;

const initialScale = 0.525;
const finalScale = 2.25;
const translateX = "-50%";
const translateZ = "1px"; // XX: translateZ is used to prevent flickering in Safari
const duration = 9; // XX: duration = staggerDelay * (number of auras)
const staggerDelay = 3; // XX: staggerDelay should be equivalent to the slider delay to keep the auras in sync with the slides

const auraScale = {
  initial: {
    opacity: 1,
    scale: initialScale,
    translateX,
    translateZ,
  },
  animate: (i: number) => ({
    opacity: [0, 1, 0, 0], // XX: Opacity with the timing below prevents occasional flickering when frame updates
    scale: [initialScale, initialScale, finalScale, finalScale],
    translateX: [translateX, translateX, translateX, translateX],
    translateZ: [translateZ, translateZ, translateZ, translateZ],
    transition: {
      duration,
      delay: i * staggerDelay,
      repeat: Number.POSITIVE_INFINITY,
      times: [0, 0.01, 0.99, 1],
      type: "linear",
    },
  }),
};

function Aura({ index }: { index: number }) {
  const id = useId();
  return (
    <ChakraSvg
      fill="none"
      viewBox="0 0 300 300"
      boxSize={{ base: "500px", md: "700px" }}
      pos="absolute"
      left="50%"
      right="50%"
      bottom={{ base: "-40%", md: "-60%" }}
      variants={auraScale}
      custom={index}
      initial="initial"
      animate="animate"
    >
      <circle cx="150" cy="150" r="150" fill={`url(#a-${id})`} />
      <defs>
        <radialGradient
          id={`a-${id}`}
          cx="0"
          cy="0"
          r="1"
          gradientTransform="rotate(-90 150 -.209) scale(186.3)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset=".46" stopColor="#021504" stopOpacity="0" />
          <stop offset="1" stopColor="#40DE9E" />
        </radialGradient>
      </defs>
    </ChakraSvg>
  );
}

const fadeIn = {
  hidden: { opacity: 0 },
  visible: { opacity: 1, transition: { duration: 0.25, delay: 0.4 } },
};

export function AuraAnimation() {
  return (
    <ChakraBox
      pos="absolute"
      top={0}
      bottom={0}
      right={negativeXMargin}
      left={negativeXMargin}
      overflow="hidden"
      variants={fadeIn}
      initial="hidden"
      animate="visible"
    >
      <Aura index={0} />
      <Aura index={1} />
      <Aura index={2} />
    </ChakraBox>
  );
}
